export * from './userfeedback.component';


// WEBPACK FOOTER //
// /var/www/html/foodbot_stage/web/src/app/userfeedback/index.ts